<app-header [icon]="'arrow_back_ios'" (iconClickedEvent)="back()">
</app-header>
<div class="container">
  <div class="sub-title">{{ 'view-day.title' | translate }}</div>
  <div class="sub-title-date">{{date()}}</div>
  <div class="day-container">
    @for(hour of [8,9,10,11,12,13,14,15,16,17,18,19,20]; track hour){
    <div class="hour-container">
      <span class="hours">{{hour+'h'}}</span>
        @if(appointments().get(hour.toString())){
          @for (item of appointments().get(hour.toString()); track item.id) {
            <div class="appointment-container">              
              <div class="info">
                <div class="title-container">
                  <span class="appointment-title">{{item.title}}</span>
                  <div class="actions">            
                    @if (authService.user()?.profile === PROFILES.PSYCHOLOGIST.key) {
                      <mat-icon matRipple (click)="editAppointment(item)">edit</mat-icon>
                      <mat-icon matRipple (click)="deleteAppointment(item)">delete_outline</mat-icon>
                    }
                  </div>
                </div>
                <span class="appointment-desc">{{item.description}}</span>
                <div class="time-price-container">
                  <span><mat-icon>watch</mat-icon>{{getAppointmentLocalStartEndTime(item)}}</span>
                  <span><mat-icon>credit_card</mat-icon>{{ getCurrencySymbol(item.currency ?? '') +' '+ (item.value | number: '2.2') }}</span>  
                </div>
                @if (authService.user()?.profile === PROFILES.PSYCHOLOGIST.key) {
                  <span class="patient"><mat-icon>person</mat-icon>{{item.users.first_name+' '+item.users.last_name}}</span>
                }
                <span><mat-icon>info_outline</mat-icon>{{ STATUS[item.status ?? ''].label | translate }}</span>  
                @if (item.status === STATUS.WAITING_CONFIRMATION.code) {
                  <div class="status waiting"></div>
                }
                @else if (item.status === STATUS.CONFIRMED.code) {
                  <div class="status confirmed"></div>
                }
                @else if (item.status === STATUS.REJECTED.code) {
                  <div class="status rejected"></div>
                }                                
                @if (
                  authService.user()?.profile !== PROFILES.PSYCHOLOGIST.key                  
                ) {
                  <div class="confirm-container">
                    <span matRipple>{{ 'view-day.confirm_attend' | translate }}</span>
                    @if (item.status !== STATUS.CONFIRMED.code) {
                      <div class="positive" (click)="attendance(item.id, true)"><mat-icon>thumb_up</mat-icon></div>
                    }
                    @if(item.status !== STATUS.REJECTED.code) {
                      <div class="negative" (click)="attendance(item.id, false)"><mat-icon>thumb_down</mat-icon></div>
                    }
                  </div>
                }
                @if(
                  (authService.user()?.profile === PROFILES.PSYCHOLOGIST.key && item.calendar_id) || 
                  (authService.user()?.profile !== PROFILES.PSYCHOLOGIST.key && item.status === STATUS.CONFIRMED.code && item.calendar_id)
                ){
                  <div class="google-calendar">
                    @if(authService.user()?.profile === PROFILES.PSYCHOLOGIST.key){
                      <div class="calendar">
                        <img src="/imgs/google-calendar.png" alt="Google Calendar icon" />
                        <span>{{ 'view-day.sync' | translate }}</span>
                      </div>
                    }
                    <div matRipple class="meet" (click)="startSession(item)">
                      <img src="/imgs/google-meet.png" alt="Google Calendar icon" />
                      <span>{{ 'view-day.start_session' | translate }}</span>
                    </div>                  
                  </div>
                }
              </div>
            </div>
          }
        }
    </div>
    }
  </div>
</div>